import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`

  #page {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    white-space: pre-wrap;
    #footer {
      white-space: normal;
    }
    #header {
      white-space: normal;
    }
  }

  body {
    margin: 0;
    padding: 0;
    background-color: var(--glz-color-neutral-tone-0);
    font-family: "Noto Sans", 'Dejavu Sans', Geneva, Tahoma, sans-serif;
  }

  .popup-open {
    overflow: hidden;
  }

  #root {
    flex-grow: 1;
    display: flex;
    align-items: stretch;
  }
  

  .popup-main.popup-main {
    max-width: 584px;
    margin: 160px auto;
      @media (max-width: 646px) {
        max-height: 500px;
        border-radius: 10px;
        min-height: max-content;
      }
  }

  .glz-popup-outer-wrapper {
    padding: 10px;
    
    @media (max-width: 900px) {
      border-radius: 10px;
    }
  }

  .popup-footer {
    justify-content: space-around;
    @media (max-width: 646px) {
      border-radius: 10px;
    }
  }
`;

export default GlobalStyles;
